import { z } from "zod";

/** Lifecycle for a website digest issue (matches `website_digest_issue_status` enum). */
export const WebsiteDigestIssueStatusSchema = z.enum([
  "draft",
  "pending_review",
  "published",
  "rejected",
  "archived",
]);

export type WebsiteDigestIssueStatus = z.infer<typeof WebsiteDigestIssueStatusSchema>;

export const WebsiteDigestSourceAttributionSchema = z.object({
  label: z.string(),
  url: z.string().url().optional(),
  newsletter: z.string().optional(),
});

export type WebsiteDigestSourceAttribution = z.infer<
  typeof WebsiteDigestSourceAttributionSchema
>;

export const WebsiteDigestIssueSchema = z.object({
  id: z.string().uuid(),
  channel_id: z.string().uuid(),
  slug: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  title: z.string().min(1),
  week_start: z.string(),
  week_end: z.string(),
  status: WebsiteDigestIssueStatusSchema,
  markdown_body: z.string().nullable(),
  sources_json: z.array(WebsiteDigestSourceAttributionSchema),
  seo_title: z.string().nullable().optional(),
  seo_description: z.string().nullable().optional(),
  published_at: z.string().nullable(),
  byline: z.string().optional(),
});

export type WebsiteDigestIssue = z.infer<typeof WebsiteDigestIssueSchema>;

/** Default public channel slug for the FlowState marketing digest. */
export const FLOWSTATE_DIGEST_CHANNEL_SLUG = "flowstate";

/** MVP TLDR sender patterns (Gmail allow-list; extend via channel row). */
export const MVP_DIGEST_SENDER_PATTERNS = [
  "%@tldrnewsletter.com",
  "%@tldr.tech",
] as const;

export const WebsiteDigestExtractedItemSchema = z.object({
  headline: z.string(),
  articleUrl: z.string().url(),
  sourceNewsletter: z.string(),
  blurb: z.string().optional(),
});

export type WebsiteDigestExtractedItem = z.infer<
  typeof WebsiteDigestExtractedItemSchema
>;
